// extracted by mini-css-extract-plugin
module.exports = {"TabNavContentWrapper":"TabNavContentWrapper___3WCNc","TabNavContentWrapper__noPadding":"TabNavContentWrapper__noPadding___3sEyK","TabNavLabelWrapper":"TabNavLabelWrapper___16GZU"};